import { TUserState } from '../../types/user';

export function isSameAuthenticatedUser(currentUser: TUserState, nextUser: TUserState) {
  if (!currentUser.isAuthenticated || !nextUser.isAuthenticated) {
    return false;
  }

  const hasStableId = currentUser.userId !== null || currentUser.realtyId !== null;

  return hasStableId && currentUser.userId === nextUser.userId && currentUser.realtyId === nextUser.realtyId;
}

export function isSameAuthenticatedSession(requestedUser: TUserState, currentUser: TUserState) {
  return requestedUser === currentUser || isSameAuthenticatedUser(requestedUser, currentUser);
}
